<template>
  <vl-map
    :data-projection="'EPSG:4326'"
    @singleclick="onMapClick"
    @pointermove="onMapHover"
    @postcompose="resize"
    :load-tiles-while-animating="true"
    :load-tiles-while-interacting="true"
    style="width:100%; height:100%;"
    ref="map"
    @mounted="onMapMounted"
  >
    <vl-view
      :projection="'EPSG:4326'"
      ref="mapView"
      :zoom.sync="zoomMap"
      :center.sync="centerMap"
      :rotation="rotationMap"
    ></vl-view>

    <vl-layer-vector id="draw-pane" :z-index="100">
      <vl-source-vector
        ref="drawnFeatures"
        ident="draw-target"
        :features.sync="drawnFeatures"
      ></vl-source-vector>
      <vl-style-box>
        <vl-style-circle :radius="5">
          <vl-style-stroke color="#f57c00" :width="3"></vl-style-stroke>
          <vl-style-fill color="#f57c00"></vl-style-fill>
        </vl-style-circle>
        <vl-style-stroke color="#f57c00" :width="3"></vl-style-stroke>
        <vl-style-fill color="rgba(255,255,255,0.5)"></vl-style-fill>
      </vl-style-box>
    </vl-layer-vector>
    <vl-interaction-select
      ident="modify-target"
      :layers="['draw-pane']"
      :features.sync="selectedFeatures"
    >
    </vl-interaction-select>
    <vl-interaction-modify source="draw-target"></vl-interaction-modify>
    <vl-interaction-snap
      source="draw-target"
      :priority="10"
    ></vl-interaction-snap>
    <vl-interaction-draw
      :type="typeDraw"
      :active="active"
      source="draw-target"
      @drawend="onDrawEnd"
    >
    </vl-interaction-draw>

    <!-- charge les differents fond de carte ou niveau-->
    <vl-layer-tile
      v-for="layer in allLayers"
      :key="layer.layerName"
      :id="layer.layerName"
      :visible="layer.checked"
      :opacity="layer.opacity"
      :z-index="layer.zindex"
    >
      <!-- clicmap mapserver sans proxy -->
      <vl-source-wms
        v-if="layer.type == 'mapserver'"
        :url="layer.url"
        :layers="layer.layerName"
        :format="layer.format"
        :styles="''"
        :extParams="{ MAP: layer.map }"
        :projection="layer.projection"
        :SRS="layer.projection"
      ></vl-source-wms>
      <!-- si le fond de carte est type OSM  -->
      <vl-source-osm v-if="layer.type == 'OSM'"></vl-source-osm>
      <!-- si le fond de carte est type WMTS -->
      <vl-source-wmts
        v-if="layer.type == 'IGN'"
        :url="layer.url"
        :layer-name="layer.layerName"
        :matrix-set="layer.matrix"
        :format="layer.format"
        styleName="normal"
      >
      </vl-source-wmts>
    </vl-layer-tile>

    <!-- charge les different layer vector si il y a -->
    <vl-layer-vector
      :visible="vectorLayer.visible"
      v-for="vectorLayer in vectorLayerToShow"
      :key="vectorLayer.ref"
      :id="vectorLayer.ref"
      :z-index="vectorLayer.vectorZIndex"
    >
      <vl-source-vector
        :projection="'EPSG:4326'"
        :ident="vectorLayer.ref"
        render-mode="image"
        :ref="vectorLayer.ref"
        :features="vectorLayer.features"
      >
        <vl-style-func :factory="vectorLayer.factory"></vl-style-func>
      </vl-source-vector>
    </vl-layer-vector>
    <!-- interaction modify -->
    <div
      v-for="vectorLayer in vectorLayerToShow"
      :key="vectorLayer.ref + '-movePoint'"
    >
      <vl-interaction-modify
        @modifyend="onMovePoint($event)"
        v-if="
          vectorLayer.movePoint != 'undefined' && vectorLayer.movePoint == true
        "
        :source="vectorLayer.ref"
      >
        <vl-style-func :factory="vectorLayer.factory"></vl-style-func>
      </vl-interaction-modify>
    </div>
    <!-- interaction select -->
    <div
      v-for="vectorLayer in vectorLayerToShow"
      :key="vectorLayer.ref + '-select'"
    >
      <vl-interaction-select
        :features.sync="selectedFeatures"
        v-if="vectorLayer.select != 'undefined' && vectorLayer.select == true"
        :source="vectorLayer.ref"
      >
        <template slot-scope="select">
          <vl-style-func :factory="vectorLayer.factory"></vl-style-func>
          <vl-overlay
            class="feature-popup"
            v-for="feature in selectedFeatures"
            :key="feature.id"
            :id="feature.id"
            :offset="[-75, -70]"
            :position="pointOnSurface(feature.geometry)"
          >
            <template slot-scope="popup">
              <b-card class="popup-map">
                <b-row class="no-margin h-100 w-100">
                  <b-col cols="4" class="no-padding">
                    <div
                      :class="
                        'text-center link-detail' +
                          ' statut-' +
                          feature.properties.state_id
                      "
                    >
                      <div class="text">{{ feature.properties.id }}</div>
                      <!--  -->
                      <div
                        class="hover-thumb"
                        @click="vectorLayer.click(feature.properties.id)"
                      >
                        <font-awesome-icon icon="eye"></font-awesome-icon>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="8" class="no-padding info ">
                    <div
                      v-if="feature.properties.date_start"
                      class="date_start"
                    >
                      <font-awesome-icon icon="wrench"></font-awesome-icon>
                      {{ feature.properties.date_start }}
                    </div>
                    <div v-if="feature.properties.date_start" class="date_end">
                      <font-awesome-icon icon="clock"></font-awesome-icon>
                      {{ feature.properties.date_end }}
                    </div>
                    <div class="error-date" v-else>
                      <font-awesome-icon
                        icon="exclamation-triangle"
                      ></font-awesome-icon>
                      Pas de date
                    </div>
                  </b-col>
                </b-row>
              </b-card>
            </template>
          </vl-overlay>
        </template>
      </vl-interaction-select>
    </div>
    <div class="card card-layer" v-show="showLayers" v-if="layers.length > 0">
      <span v-for="layer in layers" :key="layer.layerName">
        <b-form-checkbox v-model="layer.checked" switch>
          {{ layer.text }}
        </b-form-checkbox>
      </span>
    </div>

    <!-- affichage de la selection des differnt types de cartes -->
    <!-- au clic on appelle la fonction qui affiche le layer choisi -->
    <ul class="fond-map" v-if="baseLayers.length > 0">
      <li
        v-for="layer in baseLayers"
        @click="setLayersSwitchPannel(layer.layerName)"
        :key="layer.layerName"
        :id="layer.layerName"
        :class="layer.checked == true ? 'selected' : ''"
      >
        {{ layer.text }}
      </li>
    </ul>

    <div v-if="draw" class="lst-actions-map">
      <b-button
        :class="
          active == true && typeDraw == 'MultiPoint'
            ? 'point selected'
            : 'point'
        "
        variant="white"
        @click="setPoint()"
      >
        <font-awesome-icon icon="dot-circle"></font-awesome-icon>
      </b-button>
      <b-button
        :class="
          active == true && typeDraw == 'MultiLineString'
            ? 'line selected'
            : 'line'
        "
        variant="white"
        @click="setLine()"
      >
        <font-awesome-icon icon="grip-lines"></font-awesome-icon>
      </b-button>
      <b-button
        :class="
          active == true && typeDraw == 'MultiPolygon'
            ? 'polygon selected'
            : 'polygon'
        "
        variant="white"
        @click="setPolygon()"
      >
        <font-awesome-icon icon="draw-polygon"></font-awesome-icon>
      </b-button>
      <b-button class="delete" variant="white" @click="remove()">
        <font-awesome-icon icon="trash-alt"></font-awesome-icon>
      </b-button>
    </div>
    <div class="calques-map">
      <b-button @click="showLayers = !showLayers" variant="white" class="btn">
        <font-awesome-icon icon="layer-group"></font-awesome-icon>
      </b-button>
    </div>
  </vl-map>
</template>
<script>
import {
  createProj,
  addProj,
  findPointOnSurface,
  createStyle,
  createMultiPointGeom,
  loadingBBox,
} from "vuelayers/lib/ol-ext";
import Vuex from "vuex";
import ScaleLine from "ol/control/ScaleLine";
import FullScreen from "ol/control/FullScreen";
import OverviewMap from "ol/control/OverviewMap";
import DragAndDrop from "ol/interaction/DragAndDrop";
import ZoomSlider from "ol/control/ZoomSlider";
import Vue from "vue";
import * as olExtent from "ol/extent";
import Point from "ol/geom/Point";
import * as proj from "ol/proj";
export default {
  name: "Maps",

  data: () => ({
    showLayers: false,
    vectorZIndex: 5,
    drawnFeatures: [],
    selectedFeatures: [],
    active: false,
    typeDraw: "Circle",
    select: [],
  }),
  props: ["vectorLayers", "width", "defaultLayers", "draw"],
  computed: {
    vectorLayerToShow() {
      let tab = [];
      this.vectorLayers.forEach((layer) => {
        if (typeof layer.features != "undefined" && layer.features.length > 0) {
          tab.push(layer);
        }
      });
      return tab;
    },
    ...Vuex.mapGetters("Map", [
      "rotation",
      "zoom",
      "center",
      "layers",
      "baseLayers",
      "allLayers",
      "configlayers",
      "extent",
    ]),
    centerMap: {
      get() {
        return this.center;
      },
      set(newVal) {
        this.updateViewCenter(newVal);
        this.setExtent(
          proj.transformExtent(
            this.$refs.mapView.$view.calculateExtent(),
            "EPSG:3857",
            "EPSG:4326"
          )
        );
      },
    },
    zoomMap: {
      get() {
        return this.zoom;
      },
      set(newVal) {
        this.updateViewZoom(newVal);
        this.setExtent(
          proj.transformExtent(
            this.$refs.mapView.$view.calculateExtent(),
            "EPSG:3857",
            "EPSG:4326"
          )
        );
      },
    },
    rotationMap: {
      get() {
        return this.rotation;
      },
    },
  },
  beforeCreate() {
    let me = this;
    //localise un object en tenant compte de l'extent passé en parametre
    window.Event.$on("locatePoint", (point) => {

      let extent = new Point([parseFloat(point.lon), parseFloat(point.lat)]);
      if (this.$refs.mapView) {
        this.$refs.mapView.$view.fit(extent, {
          size: [100, 100],
          maxZoom: 17,
          duration: 1000,
        });
      }
    });
    //refresh le niveau
    window.Event.$on("refreshLayer", (ref) => {
      if (this.$refs[ref][0]) {
        this.$refs[ref][0].refresh();
      }
    });
    //clear le niveau
    window.Event.$on("clearLayer", (ref) => {
      if (this.$refs[ref][0]) {
        this.$refs[ref][0].clear();
      } else if (this.$refs[ref]) {
        this.$refs[ref].clear();
      }
    });
    //zoom extentlayer
    window.Event.$on("zoomLayer", (ref) => {
      let launch = false;
      ref.split(",").forEach((niveau) => {
        if (
          this.$refs &&
          this.$refs[niveau] &&
          this.$refs[niveau][0] &&
          launch == false
        ) {
          this.$refs.mapView.$view.fit(
            this.$refs[niveau][0].$source.getExtent(),
            {
              size: this.$refs.map.$map.getSize(),
              duration: 1000,
              maxZoom: 18,
            }
          );
          launch = true;
        }
      });
    });
    //refresh map
    window.Event.$on("refreshMap", () => {
      //on test si les variables existes et si la fonction existe bien
      if (
        typeof this.$refs != "undefined" &&
        typeof this.$refs["map"] != "undefined" &&
        this.$refs["map"].refresh()
      ) {
        this.$refs["map"].refresh();
      }
    });

    window.Event.$on("AddDrawnFeature", (feature) => {
      if (this.$refs.drawnFeatures) {
        this.$refs.drawnFeatures.addFeature(feature);
      }
    });
  },
  methods: {
    pointOnSurface: findPointOnSurface,
    onMovePoint(event) {
      this.$emit(
        "pointMoved",
        event.features
          .getArray()[0]
          .getGeometry()
          .getCoordinates()
      );
    },
    setPoint() {
      if (this.typeDraw == "MultiPoint") {
        this.active = false;
        this.typeDraw = "Circle";
      } else {
        this.active = true;
        this.typeDraw = "MultiPoint";
      }
    },
    setLine() {
      if (this.typeDraw == "MultiLineString") {
        this.active = false;
        this.typeDraw = "Circle";
      } else {
        this.active = true;
        this.typeDraw = "MultiLineString";
      }
    },
    setPolygon() {
      if (this.typeDraw == "MultiPolygon") {
        this.active = false;
        this.typeDraw = "Circle";
      } else {
        this.active = true;
        this.typeDraw = "MultiPolygon";
      }
    },
    remove() {
      let me = this;
      me.selectedFeatures.forEach(function(feature, selected) {
        me.drawnFeatures.forEach(function(drawn, index) {
          if (feature.id == drawn.id) {
            me.drawnFeatures.splice(index, 1);
            me.selectedFeatures.splice(selected, 1);
            // me.$refs.drawnFeatures.refresh();
          }
        });
      });
    },
    resize() {
      this.$refs.map.refresh();
    },
    onMapHover(evt) {
      let me = this;
      let hit = me.$refs.map.$map.forEachFeatureAtPixel(evt.pixel, function(
        feature,
        layer
      ) {
        //TODO SE BASER SUR L'ICON
        //pour l'instant on change le clique que sur les parcelles
        //donc si l'objet parcelle existe on le change
        if (typeof feature.getProperties().plots === "undefined") {
          return true;
        }
      });
      if (hit) {
        me.$refs.map.$map.getTarget().style.cursor = "pointer";
      } else {
        me.$refs.map.$map.getTarget().style.cursor = "";
      }
    },
    onMapClick(evt) {
      let me = this;
      let features = me.$refs.map.$map.forEachFeatureAtPixel(
        evt.pixel,
        function(feature, layer) {
          me.vectorLayers.forEach(function(vectorLayer) {
            if (
              layer &&
              vectorLayer.ref === layer.get("id") &&
              vectorLayer.click &&
              vectorLayer.select == false &&
              typeof vectorLayer.click == "function"
            ) {
              vectorLayer.click(feature);
            }
          });
        }
      );
    },
    // permet de switcher entre les fond de carte
    setLayersSwitchPannel(name) {
      this.baseLayers.forEach(function(layer) {
        if (layer.baseLayer === true) {
          layer.checked = false;
        }
      });
      let layer = this.baseLayers.find((layer) => layer.layerName === name);
      if (layer != null) {
        layer.checked = true;
      }
    },
    onMapMounted(map) {
      // now ol.Map instance is ready and we can work with it directly
      map.$map.getControls().extend([new ScaleLine(), new FullScreen()]);
      this.setExtent(
        proj.transformExtent(
          this.$refs.mapView.$view.calculateExtent(),
          "EPSG:3857",
          "EPSG:4326"
        )
      );
      if (this.defaultLayers != "undefined" && this.defaultLayers.length > 0) {
        this.defaultLayers.forEach((element) => {
          this.layers.find(
            (layer) => layer.layerName === element
          ).checked = true;
        });
      } else {
        this.layers.forEach((element) => {
          element.checked = false;
        });
      }
    },
    onDrawEnd() {
      this.active = false;
      this.typeDraw = "Circle";
    },
    ...Vuex.mapActions("Map", [
      "setExtent",
      "updateViewCenter",
      "updateViewZoom",
    ]),
  },
  watch: {
    drawnFeatures: {
      deep: true,
      handler: function(val, oldVal) {
        this.$emit("featuresDrawed", val);
      },
    },
  },
};
</script>
